export default function parseXml(tag, text) {
  const match = text?.match(new RegExp(`<${tag}>([\\s\\S]*?)<\\/${tag}>`));
  return match?.[1] ?? null;
}
